import Style from "./style"
import pageArrow from "./asset/page_arrow.svg"

const ControlButton = ({ icon, label, clickEvent }) => {

    return (
        <Style.Wrapper onClick={clickEvent}>
            <Style.Icon src={icon} />
            <p>{label}</p>
            <Style.Arrow src={pageArrow} />
        </Style.Wrapper>
    )
}

export default ControlButton